// test649
(649 && 0);
